import React, { useEffect, useState } from "react";
import { RightArrowIcon } from "../../../../utils/SvgComps";
import FormButtonComponent from "../../FormControl/FormButton/FormButtonComponent";
import "./CartBandComponent.scss"

const CartBandComponent = (props) => {
    const [scrolled, setScrolled] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        const isScrolled = window.scrollY > 400;
        setScrolled(isScrolled);
  
        // Toggle class on <body> tag
        if (isScrolled) {
          document.body.classList.add("scrolled-body");
        } else {
          document.body.classList.remove("scrolled-body");
        }
      };
  
      window.addEventListener("scroll", handleScroll);
  
      // Call on mount in case user is already scrolled
      handleScroll();
  
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
    const {
        tagLine, btnAction, btnName, rightTagLine,
        showTagLine, showBtn, showShareIcon
    } = props;
    
    return (<>
        {(showBtn||showTagLine||rightTagLine)?<div className={scrolled ? "cart-band-wrapper scrolled" : "cart-band-wrapper"}>
            <div className="container">
                <div className="d-flex justify-content-md-end justify-content-center align-items-center">
                    <div className="d-flex gap-4 align-items-center flex-shape justify-content-md-end justify-content-center gap-2 w-100 ">
                        <div className="price-band d-flex justify-content-md-srart justify-content-center align-items-center gap-md-3 flex-wrap">
                        {showTagLine && 
                        <span className="pricetext" dangerouslySetInnerHTML={{
                            __html: tagLine
                        }}></span>}
                            {
                            (showTagLine && rightTagLine) &&
                            <span className="pricetext" dangerouslySetInnerHTML={{
                                __html: rightTagLine
                            }}></span>
                        }
                         </div>
                        {showBtn && 
                        <FormButtonComponent 
                            btnName={btnName}
                            leftIcon={''}
                            rightIcon={<RightArrowIcon />}
                            altText={''}
                            btnAction={btnAction}
                            isPrimary={false}
                        />}
                    
                    </div>
                    {showShareIcon && false && 
                    <button type="button" className="reset-btn">
                        <img src="/images/share-b2c-icon.svg" alt="share-icon" />
                    </button>}
                </div>
            </div>
        </div>:""}
        </>
    )
}

export default CartBandComponent